import { gql } from '@apollo/client';

export const verifyMotoristGQL = gql`
  query verifyMotorist($token: String!) {
    verifyMotorist(token: $token) {
      contract {
        _id
        username
        lang
      }
    }
  }
`;
